import { BibliographyClass, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

// TODO 工事中、型の検査が済んでいないので注意
export interface SimpleMagazine {
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyRealId: number
  searchType: SystemCode
  volume: string
  volumeNumber: string
  volumeTotal: string
  dateLabel: string
  dateIssue: string // TODO 未確認、要確認
  specialType: string
  materialFormat: SystemCode
  continuationStatus: SystemCode
  magazineCode: string
  classNo: string
  edition: string
  publicationYear: string
  price: string
  displayPrice: string
  size: string
  page: string
  revision: number
}

export const defaultSimpleMagazine = (): SimpleMagazine => ({
  bibliographyClass: BibliographyClass.Real,
  prefix: Prefix.Real,
  bibliographyRealId: 0,
  searchType: defaultSystemCode(),
  volume: '',
  volumeNumber: '',
  volumeTotal: '',
  dateLabel: '',
  dateIssue: '', // TODO 未確認、要確認
  specialType: '',
  materialFormat: defaultSystemCode(),
  continuationStatus: defaultSystemCode(),
  magazineCode: '',
  classNo: '',
  edition: '',
  publicationYear: '',
  price: '',
  displayPrice: '',
  size: '',
  page: '',
  revision: 0
})

export function SimpleMagazineFromJSON(json: any): SimpleMagazine {
  return {
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    volume: exists(json, 'volume') ? json.volume : '',
    volumeNumber: exists(json, 'volume_number') ? json.volume_number : '',
    volumeTotal: exists(json, 'volume_total') ? json.volume_total : '',
    dateLabel: exists(json, 'date_label') ? json.date_label : '',
    dateIssue: exists(json, 'date_issue') ? json.date_issue : '',
    specialType: exists(json, 'special_type') ? json.special_type : '',
    materialFormat: exists(json, 'material_format')
      ? SystemCodeFromJSON(json.material_format)
      : defaultSystemCode(),
    continuationStatus: exists(json, 'continuation_status')
      ? SystemCodeFromJSON(json.continuation_status)
      : defaultSystemCode(),
    magazineCode: exists(json, 'magazine_code') ? json.magazine_code : '',
    classNo: exists(json, 'class_no') ? json.class_no : '',
    edition: exists(json, 'edition') ? json.edition : '',
    publicationYear: exists(json, 'publication_year')
      ? json.publication_year
      : '',
    price: exists(json, 'price') ? json.price : '',
    displayPrice: exists(json, 'display_price') ? json.display_price : '',
    size: exists(json, 'size') ? json.size : '',
    page: exists(json, 'page') ? json.page : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
